import { FC } from 'react';

import { Button, Heading, TextSpacing } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { LeadTestID } from '../../test-ids';
import { ErrorMessage, ErrorWrapper } from './LeadError.styles';

type LeadErrorSpecificProps = {
    isInvalidSmsConfirm?: boolean;
    onTryAgain: () => void;
};

export const LeadError: FC<LeadErrorSpecificProps> = ({ isInvalidSmsConfirm, onTryAgain }) => {
    const { t } = useTranslations();

    const title = isInvalidSmsConfirm ? t['lead.sms_error.title'] : t['lead.error.title'];
    const message = isInvalidSmsConfirm ? t['lead.sms_error.message'] : t['lead.error.message'];

    return (
        <ErrorWrapper data-test={LeadTestID.LEAD_ERROR}>
            <TextSpacing>
                <Heading tag="h2" variant="title-400">
                    {title}
                </Heading>
                <ErrorMessage>{message}</ErrorMessage>
                <Button type="submit" variant="primary" onClick={onTryAgain}>
                    {t['lead.error.try_again']}
                </Button>
            </TextSpacing>
        </ErrorWrapper>
    );
};
